var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgLight = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: 18,
  height: 18,
  fill: "none"
}, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
  clipPath: "url(#light_svg__a)"
}, /*#__PURE__*/React.createElement("path", {
  fill: "#FEA832",
  d: "M11.11 15.226v1.192A1.58 1.58 0 0 1 9.526 18H8.473a1.58 1.58 0 0 1-1.582-1.582v-1.192c0-.295.232-.562.527-.562h3.164c.295 0 .527.267.527.562"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#FE9923",
  d: "M11.11 15.226v1.192A1.58 1.58 0 0 1 9.526 18H9v-3.336h1.582c.295 0 .527.267.527.562"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#FEDB41",
  d: "M9 4.254c-.38 0-.759.042-1.139.137a4.68 4.68 0 0 0-3.459 3.407c-.411 1.687.063 3.396 1.276 4.588.433.432.686 1.075.686 1.771v.116c0 .876.706 1.618 1.582 1.618h2.11c.875 0 1.581-.742 1.581-1.618v-.116c0-.685.264-1.35.728-1.803A4.75 4.75 0 0 0 13.746 9 4.74 4.74 0 0 0 9 4.254"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#FC3",
  d: "M13.746 9a4.75 4.75 0 0 1-1.382 3.354c-.464.453-.727 1.118-.727 1.803v.116c0 .876-.707 1.618-1.582 1.618H9V4.254A4.74 4.74 0 0 1 13.746 9"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#FEA832",
  d: "M4.153 4.898 2.66 3.407a.527.527 0 1 1 .746-.746l1.491 1.491a.527.527 0 1 1-.745.746M2.672 9.527H.527a.527.527 0 1 1 0-1.054h2.145a.527.527 0 1 1 0 1.054"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#FE9923",
  d: "M17.473 9.527h-2.145a.527.527 0 1 1 0-1.054h2.145a.527.527 0 1 1 0 1.054M13.102 4.898a.527.527 0 0 1 0-.746l1.491-1.491a.527.527 0 1 1 .746.746l-1.492 1.49a.527.527 0 0 1-.745 0"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#FEA832",
  d: "M9.527.527v2.145A.52.52 0 0 1 9 3.199a.52.52 0 0 1-.527-.527V.527C8.473.232 8.705 0 9 0s.527.232.527.527"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#FE9923",
  d: "M9.527.527v2.145A.52.52 0 0 1 9 3.199V0c.295 0 .527.232.527.527"
}))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
  id: "light_svg__a"
}, /*#__PURE__*/React.createElement("path", {
  fill: "#fff",
  d: "M0 0h18v18H0z"
})))));
export { SvgLight as ReactComponent };
export default __webpack_public_path__ + "static/media/light.b2082eea.svg";